import axiosInstance from '../../helpers/axiosInstance'


export default function getRubrosService () {
    return axiosInstance.get("rubros")
        .then(response => response.data)
        .catch(error => {
          throw error;
        });
}